import { render, staticRenderFns } from "./AddClientToReseller.vue?vue&type=template&id=b843cc66"
import script from "./AddClientToReseller.vue?vue&type=script&lang=js"
export * from "./AddClientToReseller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports